// src/services/signup/bootstrapService.js
import { auth, functions } from '../../firebaseConfig';
import { httpsCallable } from 'firebase/functions';

/**
 * Calls the SoT callable. We pass a rich payload so the function
 * has everything it needs even if it doesn't read from pendingOrgs.
 *
 * Payload shape we support:
 * {
 *   companyName,
 *   traderType,            // 'company' | 'sole'
 *   businessType,          // duplicate of traderType for compatibility
 *   owner: { firstName, lastName, email, mobile, phone, website },
 *   // also flattened fields for legacy backends:
 *   firstName, lastName, email, mobile, website,
 *   termsAcceptedAt
 * }
 */
export async function bootstrapSelfOrgAndRefresh(payload = {}) {
  try {
    const callable = httpsCallable(functions, 'bootstrapOrgForSelf');
    const { data } = await callable(payload);

    // Force token refresh so we get { orgId, role } immediately
    await auth.currentUser?.getIdToken(true);

    return { ok: true, data };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('bootstrapOrgForSelf error:', e);
    let message = 'Could not complete organisation setup.';

    const raw = e?.message || e?.toString?.() || '';

    if (raw.includes('already belongs to an organisation')) {
      message = 'Your account already belongs to an organisation.';
    } else if (raw.includes('maximum number of Super Admins')) {
      message = 'This organisation already has the maximum number of Super Admins (3).';
    } else if (raw.toLowerCase().includes('missing required')) {
      message = raw; // surface server-side validation wording
    } else if (raw.toLowerCase().includes('permission-denied')) {
      message = 'You do not have permission to complete this action.';
    }

    return { ok: false, message };
  }
}
